import { render, staticRenderFns } from "./tambah-penerima.vue?vue&type=template&id=82f4798a&"
import script from "./tambah-penerima.vue?vue&type=script&lang=js&"
export * from "./tambah-penerima.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports